"use strict";

function extractVideoID(element, url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = url.match(regExp);

  if (match) {
    element.attr('data-video-id', match[7]);

    if ($('#youtube_url').length) {
      vueAccount.updateYoutube($('#youtube_url').attr('data-video-id'));
    }
  }
}

(function ($) {
  $.fn.videoID = function () {
    var that = $(this);
    that.on("change paste keyup", function () {
      extractVideoID($(this), $(this).val());
    });
  };
})(jQuery);